<template>
	<!-- <div class="flex-bar">
		<div class="flex-left">
			<span class="icon-goback"  v-show="isProCart" @click= "goBack()"></span>
		</div>
		<div class="flex-title">
			<span class="vt-middle">购物车</span>
		</div>
		<span class="flex-right">
			
		</span>
	</div> -->
	<div>
	    <mt-header :title="'购物车'" style="height: 50px">
	      <mt-button  slot="left" v-show="isProCart" @click= "goBack()">
	        <img src="../../../assets/icon/back.png" height="auto" width="8px" slot="icon" style="margin-left: 12px">
	      </mt-button>
	       <mt-button slot="right">
	       	<span class="edite" @click="editeToggle">{{isEdite ? '完成':'编辑'}}</span>
	       </mt-button>
	    </mt-header>
	    <hr style="height: 1px;background-color: #d8d8d8;"/>
  </div>
</template>

<script>
	import Vue from 'vue';
	import { mapState } from 'vuex'
	
	export default {
		name: 'aressBar',
		props: ['isProCart','isEdite','path'],
		data() {
			return {

			}
		},
		computed: mapState({
			navShows: state => state.homeState.navBtnShow,
		}),
		components: {
		},
		methods:{
      goBack () {
        this.$router.push('/productdetail/'+localStorage.getItem('goodsChannelId-cache'))

      },
			navShowClick(){
				this.$emit('navShowClick');
			},
			editeToggle(){
				this.$emit('editeToggle');
			}
			
		}
	}
</script>

<style lang="scss">
	@import '../../../assets/css/mixin';

	.flex-bar {
		padding: 0 pxToRem(30px);
		display: flex;
		justify-content: space-around;
		height: pxToRem(100px);
		line-height: pxToRem(100px);
		border-bottom: 1px solid #eee;

		.flex-left,.flex-right{
			width: pxToRem(60px);
		}
	}

	.flex-title {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		background-color: rgba(255,255,255,0.90);
	}
	.edite {
		display: inline-block;
		width: pxToRem(60px);
		color: #666;
	}

	
</style>


// WEBPACK FOOTER //
// shoppingCartHeader.vue?56fd87fd